import React from 'react';
//import { IVerse,IQuestion,IQuiz, } from '../model/Interfaces';
import QuizQuestion from './QuizQuestion';
import QuizVerse from './QuizVerse';
import {getQuiz} from '../services/Quiz';
import {IQuestion, IQuizQuestionResult, IVerse} from '../model/Interfaces';

export interface IQuizEngineProps{
    book: string,
    chapters: number[],
    length: number,
    mode:number,
    excludeVerses?: boolean,
    excludeQuestions?: boolean
}

function QuizEngine(props:IQuizEngineProps):React.ReactElement{
    const [quizCounts,setQuizCounts] = React.useState({prompt:0,value:0,maxvalue:0});
    const [prompt,setPrompt] = React.useState(Array());
    const [isLoaded,setIsLoaded] = React.useState(false);

    React.useEffect(()=>{
        getQuiz(props.book,props.chapters,props.length).then( quiz => {
            const ql = quiz.Questions.length;
            //If exclude verse or tournament mode, set verse count to 0 (don't show any of them)
            const vl = props.excludeVerses || props.mode==1 ? 0 :quiz.Verses.length;

            setIsLoaded(true);
            if (vl===0 && ql === 0) return;

            //Sort questions by chapter
            quiz.Questions.sort((a,b)=>(a.chapterno - b.chapterno));
            
            const tempList = [];

            if (vl === 0 || props.mode==1){
                quiz.Questions.forEach(q=> {tempList.push(q)});
            } else {
                let primaryLength = 0;
                let secondaryLength=0;
                let primary:any[] = [];
                let secondary:any[] = [];

                if (ql>=vl){
                    primaryLength =ql;
                    secondaryLength=vl;
                    primary = quiz.Questions;
                    secondary=quiz.Verses;
                } else {
                    primaryLength =vl;
                    secondaryLength=ql;
                    primary = quiz.Verses;
                    secondary=quiz.Questions;
                }
                const interval =Math.floor(primaryLength/secondaryLength);
                let j=0;

                for(let i=0;i<primaryLength;i++)
                {
                    if (((i+1)%interval) === 0 && j <vl){
                        //show secondarylist
                        tempList.push(secondary[j]);
                        j++;
                    }
                    tempList.push(primary[i]);
                }

                for (let i=j;j<secondaryLength;j++){
                    tempList.push(secondary[i]);
                }
            }

            let maxvalue = 0;

            tempList.forEach( element => {
                if (element.value != null){
                    maxvalue += element.value;
                } else {
                    let maxval=0;

                    if (element.answers != null){
                        (element as IQuestion).answers.forEach( value => {
                            if (maxval < value.value) maxval = value.value;
                    
                        });
                    }
                    maxvalue += maxval;
                }
            });
            
            const x = {
                prompt: quizCounts.prompt,
                maxvalue: maxvalue,
                value: quizCounts.value};
            setQuizCounts(x);                
            setPrompt(tempList);

        })},[]);

    const onAnswer=(QuestionNumber:number, Result:IQuizQuestionResult)=>{
        let x = {
            prompt: quizCounts.prompt,
            maxvalue: quizCounts.maxvalue,
            value: quizCounts.value+Result.value};
        setQuizCounts(x);
    }

    const onContinue= () =>{
        let x = {
            prompt: quizCounts.prompt+1,
            maxvalue: quizCounts.maxvalue,
            value: quizCounts.value};
        setQuizCounts(x);

    }

    let displayElement:React.ReactElement;

    if (!isLoaded){
        displayElement = (
            <p>Loading...</p>
        );
    } else if (prompt.length === 0) {
        displayElement = <p>There are no questions in this quiz.</p>
    } else if (quizCounts.prompt>(prompt.length-1)){
        displayElement=<div className='score-section'>
                        <p>Finished.</p>
                        <p>You earned {quizCounts.value} out of {quizCounts.maxvalue} points.</p>
                </div>
    } else if (prompt[quizCounts.prompt].verseref == null){
        
        displayElement = <QuizQuestion Question={prompt[quizCounts.prompt]}
            QuestionNumber={quizCounts.prompt}
            onAnswered={onAnswer}
            mode={props.mode}
            CssClass="question-container"
            onContinue={onContinue} />
    } else {
        displayElement =<QuizVerse 
                Verse={prompt[quizCounts.prompt]}
                CssClass="verse-container"
                onContinue={onContinue} />
    }
    return (
        <div className='quiz-container'>
            <p className='question-count'>{quizCounts.prompt+1} / {prompt.length}</p>
            {displayElement}
        </div>
    )
}

export default QuizEngine;